import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import { ContraAccount, ContraVoucherCreate, JournalEntry, JournalEntryCreate } from '../interfaces/accounting.interface';

export const JournalEntryService = {
    /** `referenceType` filters by source document; 'MANUAL' lists hand-made entries (no reference type). */
    getEntriesByInstitution: async (page: number = 0, size: number = 10, toDate?: string, referenceType?: string) => {
        const institutionId = AuthService.getSelectedInstitution();
        const response = await axios.get(`${ENDPOINTS.JOURNAL_ENTRY.LIST_BY_INSTITUTION(institutionId!)}?page=${page}&size=${size}${toDate ? `&toDate=${toDate}` : ''}${referenceType ? `&referenceType=${encodeURIComponent(referenceType)}` : ''}`);
        return response.data;
    },
    /** Reference types this institution's entries carry (filter options). */
    getReferenceTypes: async (): Promise<string[]> => {
        const institutionId = AuthService.getSelectedInstitution();
        const response = await axios.get(ENDPOINTS.JOURNAL_ENTRY.REFERENCE_TYPES(institutionId!));
        return response.data;
    },
    getEntryById: async (id: string) => {
        const response = await axios.get(ENDPOINTS.JOURNAL_ENTRY.BY_ID(id));
        return response.data;
    },
    createEntry: async (entry: JournalEntryCreate) => {
        const response = await axios.post(ENDPOINTS.JOURNAL_ENTRY.BASE, entry);
        return response.data;
    },
    postEntry: async (id: string) => {
        const response = await axios.patch(ENDPOINTS.JOURNAL_ENTRY.POST(id));
        return response.data;
    },
    getContraAccounts: async (institutionId: string): Promise<ContraAccount[]> =>
        (await axios.get(ENDPOINTS.JOURNAL_ENTRY.CONTRA_ACCOUNTS(institutionId))).data,
    createContra: async (dto: ContraVoucherCreate): Promise<JournalEntry> =>
        (await axios.post(ENDPOINTS.JOURNAL_ENTRY.CONTRA, dto)).data,
    downloadVoucherPdf: async (id: string): Promise<Blob> =>
        (await axios.get(ENDPOINTS.JOURNAL_ENTRY.VOUCHER_PDF(id), { responseType: 'blob' })).data,
    voidEntry: async (id: string, reason?: string) => {
        const response = await axios.patch(ENDPOINTS.JOURNAL_ENTRY.VOID(id), reason ? { reason } : undefined);
        return response.data;
    },
};
